import RequestManager from "../RequestManager";
import LastTouchGetTask from "../tasks/user/last-touch/LastTouchGetTask";
import store from "../../store";
import {
  setLastTouchFavorited, setLastTouchLiveChannel,
  setLastTouchProfile, setLastTouchPurchase, setLastTouchReminder,
  setLastTouchSeen
} from "../../reducers/user";
import storage from "../../components/DeviceStorage/DeviceStorage";
import Metadata from "../apa/Metadata";

function getInfoLastTouchStore(){
  const user = store.getState().user;
  return user.lasttouch || {};
}

export function isActiveLastTouchFromBackend(){
  const region = storage.getItem("region") || "";
  const configLastTouchFromBackend = Metadata.get("lasttouch_validation_config", "{\"default\":{\"enable\": false}}");
  const jsonConfigLastTouchFromBackend =configLastTouchFromBackend
  && typeof configLastTouchFromBackend === "string" ?
    JSON.parse(configLastTouchFromBackend) : configLastTouchFromBackend;

  const configRegion = jsonConfigLastTouchFromBackend
  && jsonConfigLastTouchFromBackend[region]
    ? jsonConfigLastTouchFromBackend[region]  : false;

  const configDefault = jsonConfigLastTouchFromBackend
  && jsonConfigLastTouchFromBackend.default
    ? jsonConfigLastTouchFromBackend.default : false;

 return configRegion ? configRegion.enable : configDefault.enable;
}

const LAST_TOUCH_DISPATCH_MAP = {
  seen: setLastTouchSeen,
  favorited: setLastTouchFavorited,
  profile: setLastTouchProfile,
  reminder: setLastTouchReminder,
  seenlive: setLastTouchLiveChannel,
  purchased: setLastTouchPurchase,
};

function updateLastTouchStore(type, value, toMiddleware) {
  if (toMiddleware) {
    const keys = Object.keys(LAST_TOUCH_DISPATCH_MAP);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      store.dispatch(LAST_TOUCH_DISPATCH_MAP[key](value[key]));
    }
  } else {
    const action = LAST_TOUCH_DISPATCH_MAP[type];
    if (action) {
      store.dispatch(action(value));
    }
  }
}

export async function getLastTouch(type, toMiddleware = false) {
  const lastTouchStore = getInfoLastTouchStore();
  const lastTouchStoreTargetStore = lastTouchStore && lastTouchStore[type] ? lastTouchStore[type] : null;
  const isActive = isActiveLastTouchFromBackend();
  const returnLastTouchStoreTargetStore = toMiddleware ? JSON.stringify(lastTouchStore) : lastTouchStoreTargetStore;

  if(!isActive) return returnLastTouchStoreTargetStore;

  try{
    const request = new LastTouchGetTask();
    const response = await RequestManager.addRequest(request);
    const lastTouchBackEnd = response.response.lasttouch || {};
    const lastTouchBackEndTarget = type && lastTouchBackEnd && lastTouchBackEnd[type] ? lastTouchBackEnd[type] : null;
    const value = toMiddleware ? lastTouchBackEnd : lastTouchBackEndTarget;
    updateLastTouchStore(type, value, toMiddleware)

    return toMiddleware ? JSON.stringify(lastTouchBackEnd) : lastTouchBackEndTarget
  }catch (e) {
    return returnLastTouchStoreTargetStore
  }
}



// WEBPACK FOOTER //
// ./src/requests/utils/utils-last-touch.js